import { render } from "./Scale.vue?vue&type=template&id=2380f036"
import script from "./Scale.vue?vue&type=script&lang=js"
export * from "./Scale.vue?vue&type=script&lang=js"

import exportComponent from "/Users/user/Desktop/personal_projects/music_quiz/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__